"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (t, e) {
  for (var i in e) {
    t[i] = e[i];
  }
}(exports, function (t) {
  var e = {};function i(s) {
    if (e[s]) return e[s].exports;var r = e[s] = { i: s, l: !1, exports: {} };return t[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
  }return i.m = t, i.c = e, i.d = function (t, e, s) {
    i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: s });
  }, i.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
  }, i.t = function (t, e) {
    if (1 & e && (t = i(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var s = Object.create(null);if (i.r(s), Object.defineProperty(s, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var r in t) {
      i.d(s, r, function (e) {
        return t[e];
      }.bind(null, r));
    }return s;
  }, i.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return i.d(e, "a", e), e;
  }, i.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, i.p = "", i(i.s = 106);
}({ 106: function _(t, e, i) {
    t.exports = i(259);
  }, 16: function _(t, e, i) {
    "use strict";
    i.r(e), i.d(e, "GoogleMapsApi", function () {
      return s;
    });
    var s = function () {
      function s(t) {
        _classCallCheck(this, s);

        this.apiKey = t;
      }

      _createClass(s, [{
        key: "load",
        value: function load() {
          var _this = this;

          return new Promise(function (t) {
            if (_this.resolve = t, void 0 === window.humanForward && (window.humanForward = {}), window.humanForward.GoogleMapsApi || (_this.callbackName = "humanForward.GoogleMapsApi.mapReady", window.humanForward.GoogleMapsApi = _this, window.humanForward.GoogleMapsApi.mapReady = _this.mapReady.bind(_this)), void 0 !== window.google && void 0 !== window.google.maps || void 0 === _this.callbackName) _this.resolve();else {
              _this.loaded = !0;var _t = document.createElement("script");_t.src = "//maps.googleapis.com/maps/api/js?key=" + _this.apiKey + "&callback=" + _this.callbackName, _t.async = !0, document.body.appendChild(_t);
            }
          });
        }
      }, {
        key: "mapReady",
        value: function mapReady() {
          this.extendApi(), this.resolve();
        }
      }, {
        key: "extendApi",
        value: function extendApi() {
          google.maps.Map.prototype.panToWithOffset = function (t, e, i) {
            var s = this,
                r = new google.maps.OverlayView();r.onAdd = function () {
              var r = this.getProjection(),
                  o = r.fromLatLngToContainerPixel(t);o.x = o.x + e, o.y = o.y + i, s.panTo(r.fromContainerPixelToLatLng(o));
            }, r.draw = function () {}, r.setMap(this);
          };
        }
      }]);

      return s;
    }();
  }, 17: function _(t, e, i) {
    "use strict";
    i.r(e), i.d(e, "MapStyle", function () {
      return s;
    });
    var s = function () {
      function s() {
        _classCallCheck(this, s);
      }

      _createClass(s, null, [{
        key: "custom",
        get: function get() {
          return [{ featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] }, { featureType: "administrative.locality", elementType: "labels", stylers: [{ visibility: "simplified" }] }, { featureType: "administrative.neighborhood", stylers: [{ visibility: "off" }] }, { featureType: "administrative.province", elementType: "labels", stylers: [{ visibility: "off" }] }, { featureType: "landscape.natural", elementType: "geometry.fill", stylers: [{ color: "#f7f5f0" }] }, { featureType: "poi", elementType: "labels.text", stylers: [{ visibility: "off" }] }, { featureType: "poi.business", stylers: [{ visibility: "off" }] }, { featureType: "transit", stylers: [{ visibility: "off" }] }, { featureType: "water", elementType: "labels.text", stylers: [{ visibility: "off" }] }];
        }
      }]);

      return s;
    }();
  }, 18: function _(t, e, i) {
    "use strict";
    i.r(e), i.d(e, "PopupWrapper", function () {
      return s;
    });
    var s = function () {
      function s() {
        _classCallCheck(this, s);
      }

      _createClass(s, null, [{
        key: "popupClass",
        get: function get() {
          function t(t, e, i) {
            this.position = t, this.content = e, this.marker = i, this.content.classList.add("popup-bubble"), this.containerDiv = document.createElement("div"), this.containerDiv.classList.add("popup-bubble__container"), this.containerDiv.appendChild(e), google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);
          }return t.prototype = Object.create(google.maps.OverlayView.prototype), t.prototype.onAdd = function () {
            this.getPanes().floatPane.appendChild(this.containerDiv), this.show();
          }, t.prototype.onRemove = function () {
            this.containerDiv.parentElement && this.containerDiv.parentElement.removeChild(this.containerDiv);
          }, t.prototype.draw = function () {
            var t = this.getProjection().fromLatLngToDivPixel(this.position),
                e = Math.abs(t.x) < 4e3 && Math.abs(t.y) < 4e3 ? "block" : "none";"block" === e && (this.containerDiv.style.left = t.x + "px", this.containerDiv.style.top = t.y + "px"), this.containerDiv.style.display !== e && (this.containerDiv.style.display = e);
          }, t.prototype.height = function () {
            return getComputedStyle(this.content).getPropertyValue("height");
          }, t.prototype.hide = function () {
            var _this2 = this;

            this.content.addEventListener("transitionend", function () {
              getComputedStyle(_this2.content).getPropertyValue("opacity") <= .1 && _this2.setMap(null);
            }), this.content.classList.remove("active");
          }, t.prototype.show = function () {
            var _this3 = this;

            setTimeout(function () {
              _this3.content.classList.add("active"), setTimeout(function () {
                var t = parseInt(getComputedStyle(_this3.content).getPropertyValue("height"));if (!isNaN(t)) {
                  var _e = -1 * (t / 2 + _this3.marker.icon.size.height);_this3.marker.map.panToWithOffset(_this3.marker.getPosition(), 0, _e);
                }
              });
            }, 50);
          }, t;
        }
      }]);

      return s;
    }();
  }, 259: function _(t, e, i) {
    "use strict";
    i.r(e), i.d(e, "Maps", function () {
      return f;
    });var s = i(16),
        r = i(17),
        o = i(18),
        _n = function n(t, e) {
      return (_n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      })(t, e);
    };function a(t, e) {
      function i() {
        this.constructor = t;
      }_n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i());
    }var _l = function l() {
      return (_l = Object.assign || function (t) {
        for (var e, i = 1, s = arguments.length; i < s; i++) {
          for (var r in e = arguments[i]) {
            Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }
        }return t;
      }).apply(this, arguments);
    };var h = function t() {
      !function (t, e) {
        for (var i in e.prototype) {
          t.prototype[i] = e.prototype[i];
        }
      }(t, google.maps.OverlayView);
    };function p(t) {
      return Object.keys(t).reduce(function (e, i) {
        return t[i] && e.push(i + ":" + t[i]), e;
      }, []).join(";");
    }function u(t) {
      return t ? t + "px" : void 0;
    }var c = function (t) {
      function e(e, i) {
        var s = t.call(this) || this;return s.cluster_ = e, s.styles_ = i, s.center_ = null, s.div_ = null, s.sums_ = null, s.visible_ = !1, s.style = null, s.setMap(e.getMap()), s;
      }return a(e, t), e.prototype.onAdd = function () {
        var t,
            e,
            i = this,
            s = this.cluster_.getMarkerClusterer(),
            r = google.maps.version.split("."),
            o = r[0],
            n = r[1],
            a = 100 * parseInt(o, 10) + parseInt(n, 10);this.div_ = document.createElement("div"), this.visible_ && this.show(), this.getPanes().overlayMouseTarget.appendChild(this.div_), this.boundsChangedListener_ = google.maps.event.addListener(this.getMap(), "bounds_changed", function () {
          e = t;
        }), google.maps.event.addDomListener(this.div_, "mousedown", function () {
          t = !0, e = !1;
        }), google.maps.event.addDomListener(this.div_, "contextmenu", function () {
          google.maps.event.trigger(s, "contextmenu", i.cluster_);
        }), a >= 332 && google.maps.event.addDomListener(this.div_, "touchstart", function (t) {
          t.stopPropagation();
        }), google.maps.event.addDomListener(this.div_, "click", function (r) {
          if (t = !1, !e) {
            if (google.maps.event.trigger(s, "click", i.cluster_), google.maps.event.trigger(s, "clusterclick", i.cluster_), s.getZoomOnClick()) {
              var o = s.getMaxZoom(),
                  n = i.cluster_.getBounds();s.getMap().fitBounds(n), setTimeout(function () {
                s.getMap().fitBounds(n), null !== o && s.getMap().getZoom() > o && s.getMap().setZoom(o + 1);
              }, 100);
            }r.cancelBubble = !0, r.stopPropagation && r.stopPropagation();
          }
        }), google.maps.event.addDomListener(this.div_, "mouseover", function () {
          google.maps.event.trigger(s, "mouseover", i.cluster_);
        }), google.maps.event.addDomListener(this.div_, "mouseout", function () {
          google.maps.event.trigger(s, "mouseout", i.cluster_);
        });
      }, e.prototype.onRemove = function () {
        this.div_ && this.div_.parentNode && (this.hide(), google.maps.event.removeListener(this.boundsChangedListener_), google.maps.event.clearInstanceListeners(this.div_), this.div_.parentNode.removeChild(this.div_), this.div_ = null);
      }, e.prototype.draw = function () {
        if (this.visible_) {
          var t = this.getPosFromLatLng_(this.center_);this.div_.style.top = t.y + "px", this.div_.style.left = t.x + "px";
        }
      }, e.prototype.hide = function () {
        this.div_ && (this.div_.style.display = "none"), this.visible_ = !1;
      }, e.prototype.show = function () {
        this.div_ && (this.div_.className = this.className_, this.div_.style.cssText = this.createCss_(this.getPosFromLatLng_(this.center_)), this.div_.innerHTML = (this.style.url ? this.getImageElementHtml() : "") + this.getLabelDivHtml(), void 0 === this.sums_.title || "" === this.sums_.title ? this.div_.title = this.cluster_.getMarkerClusterer().getTitle() : this.div_.title = this.sums_.title, this.div_.style.display = ""), this.visible_ = !0;
      }, e.prototype.getLabelDivHtml = function () {
        var t = this.cluster_.getMarkerClusterer().ariaLabelFn(this.sums_.text),
            e = { position: "absolute", top: u(this.anchorText_[0]), left: u(this.anchorText_[1]), color: this.style.textColor, "font-size": u(this.style.textSize), "font-family": this.style.fontFamily, "font-weight": this.style.fontWeight, "font-style": this.style.fontStyle, "text-decoration": this.style.textDecoration, "text-align": "center", width: u(this.style.width), "line-height": u(this.style.textLineHeight) };return '\n<div aria-label="'.concat(t, '" style="').concat(p(e), '" tabindex="0">\n  <span aria-hidden="true">').concat(this.sums_.text, "</span>\n</div>\n");
      }, e.prototype.getImageElementHtml = function () {
        var t = (this.style.backgroundPosition || "0 0").split(" "),
            e = parseInt(t[0].replace(/^\s+|\s+$/g, ""), 10),
            i = parseInt(t[1].replace(/^\s+|\s+$/g, ""), 10),
            s = {};if (this.cluster_.getMarkerClusterer().getEnableRetinaIcons()) s = { width: u(this.style.width), height: u(this.style.height) };else {
          var r = [-1 * i, -1 * e + this.style.width, -1 * i + this.style.height, -1 * e],
              o = r[1],
              n = r[2],
              a = r[3];s = { clip: "rect(".concat(r[0], "px, ").concat(o, "px, ").concat(n, "px, ").concat(a, "px)") };
        }var h = this.sums_.url ? { width: "100%", height: "100%" } : {},
            c = p(_l(_l({ position: "absolute", top: u(i), left: u(e) }, s), h));return '<img alt="'.concat(this.sums_.text, '" aria-hidden="true" src="').concat(this.style.url, '" style="').concat(c, '"/>');
      }, e.prototype.useStyle = function (t) {
        this.sums_ = t;var e = Math.max(0, t.index - 1);e = Math.min(this.styles_.length - 1, e), this.style = this.sums_.url ? _l(_l({}, this.styles_[e]), { url: this.sums_.url }) : this.styles_[e], this.anchorText_ = this.style.anchorText || [0, 0], this.anchorIcon_ = this.style.anchorIcon || [Math.floor(this.style.height / 2), Math.floor(this.style.width / 2)], this.className_ = this.cluster_.getMarkerClusterer().getClusterClass() + " " + (this.style.className || "cluster-" + e);
      }, e.prototype.setCenter = function (t) {
        this.center_ = t;
      }, e.prototype.createCss_ = function (t) {
        return p({ "z-index": "".concat(this.cluster_.getMarkerClusterer().getZIndex()), top: u(t.y), left: u(t.x), width: u(this.style.width), height: u(this.style.height), cursor: "pointer", position: "absolute", "-webkit-user-select": "none", "-khtml-user-select": "none", "-moz-user-select": "none", "-o-user-select": "none", "user-select": "none" });
      }, e.prototype.getPosFromLatLng_ = function (t) {
        var e = this.getProjection().fromLatLngToDivPixel(t);return e.x = Math.floor(e.x - this.anchorIcon_[1]), e.y = Math.floor(e.y - this.anchorIcon_[0]), e;
      }, e;
    }(h),
        m = function () {
      function t(t) {
        this.markerClusterer_ = t, this.map_ = this.markerClusterer_.getMap(), this.minClusterSize_ = this.markerClusterer_.getMinimumClusterSize(), this.averageCenter_ = this.markerClusterer_.getAverageCenter(), this.markers_ = [], this.center_ = null, this.bounds_ = null, this.clusterIcon_ = new c(this, this.markerClusterer_.getStyles());
      }return t.prototype.getSize = function () {
        return this.markers_.length;
      }, t.prototype.getMarkers = function () {
        return this.markers_;
      }, t.prototype.getCenter = function () {
        return this.center_;
      }, t.prototype.getMap = function () {
        return this.map_;
      }, t.prototype.getMarkerClusterer = function () {
        return this.markerClusterer_;
      }, t.prototype.getBounds = function () {
        for (var t = new google.maps.LatLngBounds(this.center_, this.center_), e = this.getMarkers(), i = 0; i < e.length; i++) {
          t.extend(e[i].getPosition());
        }return t;
      }, t.prototype.remove = function () {
        this.clusterIcon_.setMap(null), this.markers_ = [], delete this.markers_;
      }, t.prototype.addMarker = function (t) {
        if (this.isMarkerAlreadyAdded_(t)) return !1;if (this.center_) {
          if (this.averageCenter_) {
            var e = this.markers_.length + 1,
                i = (this.center_.lat() * (e - 1) + t.getPosition().lat()) / e,
                s = (this.center_.lng() * (e - 1) + t.getPosition().lng()) / e;this.center_ = new google.maps.LatLng(i, s), this.calculateBounds_();
          }
        } else this.center_ = t.getPosition(), this.calculateBounds_();t.isAdded = !0, this.markers_.push(t);var r = this.markers_.length,
            o = this.markerClusterer_.getMaxZoom();if (null !== o && this.map_.getZoom() > o) t.getMap() !== this.map_ && t.setMap(this.map_);else if (r < this.minClusterSize_) t.getMap() !== this.map_ && t.setMap(this.map_);else if (r === this.minClusterSize_) for (var n = 0; n < r; n++) {
          this.markers_[n].setMap(null);
        } else t.setMap(null);return !0;
      }, t.prototype.isMarkerInClusterBounds = function (t) {
        return this.bounds_.contains(t.getPosition());
      }, t.prototype.calculateBounds_ = function () {
        var t = new google.maps.LatLngBounds(this.center_, this.center_);this.bounds_ = this.markerClusterer_.getExtendedBounds(t);
      }, t.prototype.updateIcon = function () {
        var t = this.markers_.length,
            e = this.markerClusterer_.getMaxZoom();if (null !== e && this.map_.getZoom() > e) this.clusterIcon_.hide();else if (t < this.minClusterSize_) this.clusterIcon_.hide();else {
          var i = this.markerClusterer_.getStyles().length,
              s = this.markerClusterer_.getCalculator()(this.markers_, i);this.clusterIcon_.setCenter(this.center_), this.clusterIcon_.useStyle(s), this.clusterIcon_.show();
        }
      }, t.prototype.isMarkerAlreadyAdded_ = function (t) {
        if (this.markers_.indexOf) return -1 !== this.markers_.indexOf(t);for (var e = 0; e < this.markers_.length; e++) {
          if (t === this.markers_[e]) return !0;
        }return !1;
      }, t;
    }(),
        g = function g(t, e, i) {
      return void 0 !== t[e] ? t[e] : i;
    },
        d = function (t) {
      function e(i, s, r) {
        void 0 === s && (s = []), void 0 === r && (r = {});var o = t.call(this) || this;return o.options = r, o.markers_ = [], o.clusters_ = [], o.listeners_ = [], o.activeMap_ = null, o.ready_ = !1, o.ariaLabelFn = o.options.ariaLabelFn || function () {
          return "";
        }, o.zIndex_ = o.options.zIndex || Number(google.maps.Marker.MAX_ZINDEX) + 1, o.gridSize_ = o.options.gridSize || 60, o.minClusterSize_ = o.options.minimumClusterSize || 2, o.maxZoom_ = o.options.maxZoom || null, o.styles_ = o.options.styles || [], o.title_ = o.options.title || "", o.zoomOnClick_ = g(o.options, "zoomOnClick", !0), o.averageCenter_ = g(o.options, "averageCenter", !1), o.ignoreHidden_ = g(o.options, "ignoreHidden", !1), o.enableRetinaIcons_ = g(o.options, "enableRetinaIcons", !1), o.imagePath_ = o.options.imagePath || e.IMAGE_PATH, o.imageExtension_ = o.options.imageExtension || e.IMAGE_EXTENSION, o.imageSizes_ = o.options.imageSizes || e.IMAGE_SIZES, o.calculator_ = o.options.calculator || e.CALCULATOR, o.batchSize_ = o.options.batchSize || e.BATCH_SIZE, o.batchSizeIE_ = o.options.batchSizeIE || e.BATCH_SIZE_IE, o.clusterClass_ = o.options.clusterClass || "cluster", -1 !== navigator.userAgent.toLowerCase().indexOf("msie") && (o.batchSize_ = o.batchSizeIE_), o.setupStyles_(), o.addMarkers(s, !0), o.setMap(i), o;
      }return a(e, t), e.prototype.onAdd = function () {
        var t = this;this.activeMap_ = this.getMap(), this.ready_ = !0, this.repaint(), this.prevZoom_ = this.getMap().getZoom(), this.listeners_ = [google.maps.event.addListener(this.getMap(), "zoom_changed", function () {
          var e = t.getMap(),
              i = e.minZoom || 0,
              s = Math.min(e.maxZoom || 100, e.mapTypes[e.getMapTypeId()].maxZoom),
              r = Math.min(Math.max(t.getMap().getZoom(), i), s);t.prevZoom_ != r && (t.prevZoom_ = r, t.resetViewport_(!1));
        }), google.maps.event.addListener(this.getMap(), "idle", function () {
          t.redraw_();
        })];
      }, e.prototype.onRemove = function () {
        for (var t = 0; t < this.markers_.length; t++) {
          this.markers_[t].getMap() !== this.activeMap_ && this.markers_[t].setMap(this.activeMap_);
        }for (t = 0; t < this.clusters_.length; t++) {
          this.clusters_[t].remove();
        }this.clusters_ = [];for (t = 0; t < this.listeners_.length; t++) {
          google.maps.event.removeListener(this.listeners_[t]);
        }this.listeners_ = [], this.activeMap_ = null, this.ready_ = !1;
      }, e.prototype.draw = function () {}, e.prototype.setupStyles_ = function () {
        if (!(this.styles_.length > 0)) for (var t = 0; t < this.imageSizes_.length; t++) {
          var i = this.imageSizes_[t];this.styles_.push(e.withDefaultStyle({ url: this.imagePath_ + (t + 1) + "." + this.imageExtension_, height: i, width: i }));
        }
      }, e.prototype.fitMapToMarkers = function (t) {
        for (var e = this.getMarkers(), i = new google.maps.LatLngBounds(), s = 0; s < e.length; s++) {
          !e[s].getVisible() && this.getIgnoreHidden() || i.extend(e[s].getPosition());
        }this.getMap().fitBounds(i, t);
      }, e.prototype.getGridSize = function () {
        return this.gridSize_;
      }, e.prototype.setGridSize = function (t) {
        this.gridSize_ = t;
      }, e.prototype.getMinimumClusterSize = function () {
        return this.minClusterSize_;
      }, e.prototype.setMinimumClusterSize = function (t) {
        this.minClusterSize_ = t;
      }, e.prototype.getMaxZoom = function () {
        return this.maxZoom_;
      }, e.prototype.setMaxZoom = function (t) {
        this.maxZoom_ = t;
      }, e.prototype.getZIndex = function () {
        return this.zIndex_;
      }, e.prototype.setZIndex = function (t) {
        this.zIndex_ = t;
      }, e.prototype.getStyles = function () {
        return this.styles_;
      }, e.prototype.setStyles = function (t) {
        this.styles_ = t;
      }, e.prototype.getTitle = function () {
        return this.title_;
      }, e.prototype.setTitle = function (t) {
        this.title_ = t;
      }, e.prototype.getZoomOnClick = function () {
        return this.zoomOnClick_;
      }, e.prototype.setZoomOnClick = function (t) {
        this.zoomOnClick_ = t;
      }, e.prototype.getAverageCenter = function () {
        return this.averageCenter_;
      }, e.prototype.setAverageCenter = function (t) {
        this.averageCenter_ = t;
      }, e.prototype.getIgnoreHidden = function () {
        return this.ignoreHidden_;
      }, e.prototype.setIgnoreHidden = function (t) {
        this.ignoreHidden_ = t;
      }, e.prototype.getEnableRetinaIcons = function () {
        return this.enableRetinaIcons_;
      }, e.prototype.setEnableRetinaIcons = function (t) {
        this.enableRetinaIcons_ = t;
      }, e.prototype.getImageExtension = function () {
        return this.imageExtension_;
      }, e.prototype.setImageExtension = function (t) {
        this.imageExtension_ = t;
      }, e.prototype.getImagePath = function () {
        return this.imagePath_;
      }, e.prototype.setImagePath = function (t) {
        this.imagePath_ = t;
      }, e.prototype.getImageSizes = function () {
        return this.imageSizes_;
      }, e.prototype.setImageSizes = function (t) {
        this.imageSizes_ = t;
      }, e.prototype.getCalculator = function () {
        return this.calculator_;
      }, e.prototype.setCalculator = function (t) {
        this.calculator_ = t;
      }, e.prototype.getBatchSizeIE = function () {
        return this.batchSizeIE_;
      }, e.prototype.setBatchSizeIE = function (t) {
        this.batchSizeIE_ = t;
      }, e.prototype.getClusterClass = function () {
        return this.clusterClass_;
      }, e.prototype.setClusterClass = function (t) {
        this.clusterClass_ = t;
      }, e.prototype.getMarkers = function () {
        return this.markers_;
      }, e.prototype.getTotalMarkers = function () {
        return this.markers_.length;
      }, e.prototype.getClusters = function () {
        return this.clusters_;
      }, e.prototype.getTotalClusters = function () {
        return this.clusters_.length;
      }, e.prototype.addMarker = function (t, e) {
        this.pushMarkerTo_(t), e || this.redraw_();
      }, e.prototype.addMarkers = function (t, e) {
        for (var i in t) {
          Object.prototype.hasOwnProperty.call(t, i) && this.pushMarkerTo_(t[i]);
        }e || this.redraw_();
      }, e.prototype.pushMarkerTo_ = function (t) {
        var e = this;t.getDraggable() && google.maps.event.addListener(t, "dragend", function () {
          e.ready_ && (t.isAdded = !1, e.repaint());
        }), t.isAdded = !1, this.markers_.push(t);
      }, e.prototype.removeMarker = function (t, e) {
        var i = this.removeMarker_(t);return !e && i && this.repaint(), i;
      }, e.prototype.removeMarkers = function (t, e) {
        for (var i = !1, s = 0; s < t.length; s++) {
          var r = this.removeMarker_(t[s]);i = i || r;
        }return !e && i && this.repaint(), i;
      }, e.prototype.removeMarker_ = function (t) {
        var e = -1;if (this.markers_.indexOf) e = this.markers_.indexOf(t);else for (var i = 0; i < this.markers_.length; i++) {
          if (t === this.markers_[i]) {
            e = i;break;
          }
        }return -1 !== e && (t.setMap(null), this.markers_.splice(e, 1), !0);
      }, e.prototype.clearMarkers = function () {
        this.resetViewport_(!0), this.markers_ = [];
      }, e.prototype.repaint = function () {
        var t = this.clusters_.slice();this.clusters_ = [], this.resetViewport_(!1), this.redraw_(), setTimeout(function () {
          for (var e = 0; e < t.length; e++) {
            t[e].remove();
          }
        }, 0);
      }, e.prototype.getExtendedBounds = function (t) {
        var e = this.getProjection(),
            i = new google.maps.LatLng(t.getNorthEast().lat(), t.getNorthEast().lng()),
            s = new google.maps.LatLng(t.getSouthWest().lat(), t.getSouthWest().lng()),
            r = e.fromLatLngToDivPixel(i);r.x += this.gridSize_, r.y -= this.gridSize_;var o = e.fromLatLngToDivPixel(s);o.x -= this.gridSize_, o.y += this.gridSize_;var n = e.fromDivPixelToLatLng(r),
            a = e.fromDivPixelToLatLng(o);return t.extend(n), t.extend(a), t;
      }, e.prototype.redraw_ = function () {
        this.createClusters_(0);
      }, e.prototype.resetViewport_ = function (t) {
        for (var e = 0; e < this.clusters_.length; e++) {
          this.clusters_[e].remove();
        }this.clusters_ = [];for (e = 0; e < this.markers_.length; e++) {
          var i = this.markers_[e];i.isAdded = !1, t && i.setMap(null);
        }
      }, e.prototype.distanceBetweenPoints_ = function (t, e) {
        var i = (e.lat() - t.lat()) * Math.PI / 180,
            s = (e.lng() - t.lng()) * Math.PI / 180,
            r = Math.sin(i / 2) * Math.sin(i / 2) + Math.cos(t.lat() * Math.PI / 180) * Math.cos(e.lat() * Math.PI / 180) * Math.sin(s / 2) * Math.sin(s / 2);return 6371 * (2 * Math.atan2(Math.sqrt(r), Math.sqrt(1 - r)));
      }, e.prototype.isMarkerInBounds_ = function (t, e) {
        return e.contains(t.getPosition());
      }, e.prototype.addToClosestCluster_ = function (t) {
        for (var e = 4e4, i = null, s = 0; s < this.clusters_.length; s++) {
          var r,
              o = (r = this.clusters_[s]).getCenter();if (o) {
            var n = this.distanceBetweenPoints_(o, t.getPosition());n < e && (e = n, i = r);
          }
        }i && i.isMarkerInClusterBounds(t) ? i.addMarker(t) : ((r = new m(this)).addMarker(t), this.clusters_.push(r));
      }, e.prototype.createClusters_ = function (t) {
        var e = this;if (this.ready_) {
          0 === t && (google.maps.event.trigger(this, "clusteringbegin", this), void 0 !== this.timerRefStatic && (clearTimeout(this.timerRefStatic), delete this.timerRefStatic));for (var i = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(), this.getMap().getBounds().getNorthEast()), s = this.getExtendedBounds(i), r = Math.min(t + this.batchSize_, this.markers_.length), o = t; o < r; o++) {
            var n = this.markers_[o];!n.isAdded && this.isMarkerInBounds_(n, s) && (!this.ignoreHidden_ || this.ignoreHidden_ && n.getVisible()) && this.addToClosestCluster_(n);
          }if (r < this.markers_.length) this.timerRefStatic = window.setTimeout(function () {
            e.createClusters_(r);
          }, 0);else {
            delete this.timerRefStatic, google.maps.event.trigger(this, "clusteringend", this);for (o = 0; o < this.clusters_.length; o++) {
              this.clusters_[o].updateIcon();
            }
          }
        }
      }, e.CALCULATOR = function (t, e) {
        for (var i = 0, s = t.length, r = s; 0 !== r;) {
          r = Math.floor(r / 10), i++;
        }return i = Math.min(i, e), { text: s.toString(), index: i, title: "" };
      }, e.withDefaultStyle = function (t) {
        return _l({ textColor: "black", textSize: 11, textDecoration: "none", textLineHeight: t.height, fontWeight: "bold", fontStyle: "normal", fontFamily: "Arial,sans-serif", backgroundPosition: "0 0" }, t);
      }, e.BATCH_SIZE = 2e3, e.BATCH_SIZE_IE = 500, e.IMAGE_PATH = "../images/m", e.IMAGE_EXTENSION = "png", e.IMAGE_SIZES = [53, 56, 66, 78, 90], e;
    }(h);var _ = null;
    var f = function () {
      function f(t) {
        _classCallCheck(this, f);

        this.map = null, this.element = t, this.locations = [], this.marker = null, this.popup = null, this.googleMapsKey = this.element.hasAttribute(this.attributes.googleMapsKey) && this.element.getAttribute(this.attributes.googleMapsKey), this.markerUrlPath = this.element.hasAttribute(this.attributes.markerUrl) ? this.element.getAttribute(this.attributes.markerUrl) : this.variables.defaultMarkerUrl, this.clusterMarkerUrlPath = this.element.hasAttribute(this.attributes.clusterMarkerUrl) ? this.element.getAttribute(this.attributes.clusterMarkerUrl) : this.variables.defaultClusterMarkerUrl, this.markerIsNotClickable = this.element.hasAttribute(this.attributes.markerIsNotClickable) || !1, this.mapPlaceholderElement = this.element.querySelector(this.attributes.mapsPlaceholderElement), this.mapElement = this.mapPlaceholderElement.appendChild(document.createElement("div")), this.clusterEnabled = this.element.getAttribute(this.attributes.cluster), this.initializeMap();
      }

      _createClass(f, [{
        key: "initializeMap",
        value: function initializeMap() {
          var _this4 = this;

          new s.GoogleMapsApi(this.googleMapsKey).load().then(function () {
            _this4.createMap(), _this4.customZoomControl(_this4.mapPlaceholderElement), _this4.handleMarkers(), _this4.addMarker(_this4.locations), _this4.clusterEnabled && _this4.setClusterMarkers();
          }).catch(function (t) {
            console.error(t);
          });
        }
      }, {
        key: "createMap",
        value: function createMap() {
          var t = parseInt(this.element.getAttribute("data-rs-maps-zoom"));isNaN(t) && (t = 6);
          var _element$getAttribute = this.element.getAttribute("data-rs-maps").split(","),
              _element$getAttribute2 = _slicedToArray(_element$getAttribute, 2),
              e = _element$getAttribute2[0],
              i = _element$getAttribute2[1];

          this.map = new google.maps.Map(this.mapPlaceholderElement, { center: new google.maps.LatLng(e, i), zoom: t, minZoom: 4, maxZoom: 17, disableDefaultUI: !0, panControl: !0, zoomControl: !1, scaleControl: !0, streetViewControl: !1, styles: r.MapStyle.custom, mapTypeId: google.maps.MapTypeId.ROADMAP });
        }
      }, {
        key: "createPopup",
        value: function createPopup() {
          null === _ && (_ = o.PopupWrapper.popupClass);
        }
      }, {
        key: "handleMarkers",
        value: function handleMarkers() {
          var _this5 = this;

          this.createPopup(), this.locations = [].slice.call(this.element.querySelectorAll("[data-rs-map-marker]")).map(function (t) {
            var _t$getAttribute$split = t.getAttribute("data-rs-map-marker").split(","),
                _t$getAttribute$split2 = _slicedToArray(_t$getAttribute$split, 2),
                e = _t$getAttribute$split2[0],
                i = _t$getAttribute$split2[1];

            var s = {};return s.lat = e.trim(), s.lng = i.trim(), s.content = document.createElement("div"), s.content.innerHTML = t.innerHTML, s;
          }), google.maps.event.addListener(this.map, "click", function () {
            null !== _this5.marker && void 0 !== _this5.marker && (_this5.marker.open = !1, _this5.marker.customPopup.hide());
          });
        }
      }, {
        key: "addMarker",
        value: function addMarker(t) {
          var _this6 = this;

          var e = { url: this.markerUrlPath, size: new google.maps.Size(34, 48) };this.markers = t.map(function (t) {
            var i = new _(new google.maps.LatLng(t.lat, t.lng), t.content);var s = new google.maps.Marker({ position: new google.maps.LatLng(t.lat, t.lng), icon: e, map: _this6.map, customPopup: i });return i.marker = s, _this6.markerIsNotClickable || google.maps.event.addListener(s, "click", function () {
              var t = !1;!0 !== s.open && (t = !0), null !== _this6.marker && s !== _this6.marker && (_this6.marker.open = !1, _this6.marker.customPopup.hide()), _this6.marker = s, t ? (_this6.marker.customPopup.setMap(_this6.marker.map), _this6.marker.open = !0) : (_this6.marker.customPopup.hide(), _this6.marker.open = !1);
            }), s;
          });
        }
      }, {
        key: "setClusterMarkers",
        value: function setClusterMarkers() {
          var t = { imagePath: this.clusterMarkerUrlPath, imageExtension: "svg", maxZoom: 15 },
              e = new d(this.map, this.markers, t).getStyles();for (var _t2 = 0; _t2 < e.length; _t2++) {
            e[_t2].textColor = "white", e[_t2].textSize = 16, e[_t2].width = 58, e[_t2].height = 66, e[_t2].textLineHeight = 66;
          }
        }
      }, {
        key: "customZoomControl",
        value: function customZoomControl(t) {
          var _this7 = this;

          var e = t.appendChild(document.createElement("div"));e.classList.add("gmaps__control-container"), e.classList.add("gmaps__control-container--loading");var i = document.createElement("div"),
              s = document.createElement("div");i.classList.add("gmaps__button--zoom"), i.classList.add("gmaps__button--zoom-in"), s.classList.add("gmaps__button--zoom"), s.classList.add("gmaps__button--zoom-out"), e.appendChild(i), e.appendChild(s), google.maps.event.addDomListener(i, "click", function () {
            _this7.map.setZoom(_this7.map.getZoom() + 1);
          }), google.maps.event.addDomListener(s, "click", function () {
            _this7.map.setZoom(_this7.map.getZoom() - 1);
          });
        }
      }, {
        key: "attributes",
        get: function get() {
          return { clusterMarkerUrl: "data-rs-maps-cluster-marker-url", markerUrl: "data-rs-maps-marker-url", markerIsNotClickable: "data-rs-maps-marker-is-not-clickable", mapsPlaceholderElement: "[data-rs-maps-placeholder]", googleMapsKey: "data-rs-maps-google-maps-key", cluster: "data-rs-maps-cluster" };
        }
      }, {
        key: "variables",
        get: function get() {
          return { defaultMarkerUrl: "../assets/image/marker.svg", defaultClusterMarkerUrl: "../assets/image/m" };
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-maps]";
        }
      }]);

      return f;
    }();
  } }));